import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpErrorHandler } from "src/app/shared/services/handle-error.service";
import { retry } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { RNTFuncionarioEntry } from "src/app/shared/entrys/rnt-funcionario.entry";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";

@Injectable()
export class DetalleEstablecimientoService
  implements RequestCRUD<RNTFuncionarioEntry, ResponseServiceModel> {
  private API_URL;
  public infoEstablecimientoHistorico :any;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService

  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  getDetalleEstablecimiento(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Establecimiento/GetParaFuncionario`,
        entry
      )
      .pipe(retry(2));
  }
  update(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  create(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  delete(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }
  getActividadesEconomicasParaFuncionario(
    entry: any
  ): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/ActividadEconomicaPrestador/ParaFuncionario/${entry}`
      )
      .pipe(retry(2));
  }

  sincronizacionActividadesEconimicas(
    entry: any
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Prestador/SincronizarActividadesEconomicas`,
        entry
      )
      .pipe(retry(2));
  }

  getDetalleEstablecimiento_2(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Establecimiento/ObtenerComparativoInfoBasica`,
        entry
      )
      .pipe(retry(2));
  }

  getDetalleEstablecimientoParaFuncionario(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Establecimiento/ObtenerComparativoInfoBasicaFunc`,
        entry
      )
      .pipe(retry(2));
  }

  getDetalleEstablecimientoPublico(
    entry: any
  ): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Establecimiento/ObtenerDetalle`,
        entry
      )
      .pipe(retry(2));
  }
  validarRenovacion(establecimientoId: number,prestadorId: number): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/Establecimiento/ValidarRenovacion/${establecimientoId == undefined ?'0':establecimientoId}/prestador/${prestadorId}`,
        {}
      )
      .pipe(retry(2));
  }
}
